import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProdutoModel } from './produto-model';
import { ServicesProduto } from './servicos-produto';

@Component({
  selector: 'app-produto',
  templateUrl: './produto.component.html',
  styleUrls: ['./produto.component.css']
})
export class ProdutoComponent implements OnInit {

  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total:number
  loading:boolean = true;
  produtos: ProdutoModel[];
  selectedProduto: ProdutoModel;
  produto: ProdutoModel;
  produtoDialog: boolean;
  submitted: boolean;
  path_imagem:string = "";
  
  constructor(private service: ServicesProduto,  
              private messageService: MessageService, 
              private confirmationService: ConfirmationService,
              private http: HttpClient) { }

  ngOnInit(): void {
    this.path_imagem = "https://triunfo.pe.gov.br/pm_tr430/wp-content/uploads/2018/03/sem-foto.jpg";
    this.pesquisar();
  }

  pesquisar(){
    this.loading = true;

    try
    {
       this.service.listarProdutos()
       .subscribe(data => {
         if(data.Success)
         {
           this.produtos = data.Response;
           this.total = this.produtos.length;
           this.loading = false;
         }         
       },
       err => console.error(err)
       );
  }
  catch(e)
  {
    alert(e);
  }
 }

 //Funções

 abrirNovo() {
  this.produto = {};
  this.produto.cod_produto = '';
  this.submitted = false;
  this.produtoDialog = true;
}

 Editar(produto: ProdutoModel) {
  this.produto = {...produto};
  this.produtoDialog = true;
}

Deletar(produto: ProdutoModel) {
  try {
    
    this.confirmationService.confirm({
      message: 'Deseja remover ' + produto.produto + '?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let resposta = this.service.removerDadosProduto(produto);
        this.loading = true;
        resposta.subscribe(data => {
          if(data.Success)
          {      
            this.messageService.add({severity:'success', summary:'Informação', detail: data.Message});
            this.loading = false;
            this.produto = {};
            this.pesquisar();
          }
        });
      }
  });


  } catch (error) {
    this.loading = false;
    alert(error)
  }
}


Salvar() {
  this.submitted = true;

  try {
    
    let resposta = this.service.gravarDadosProduto(this.produto);
    this.loading = true;
    resposta.subscribe(data => {
      if(data.Success)
      {      
        this.onUpload(data.Response);
        this.messageService.add({severity:'success', summary:'Informação', detail: data.Message});
        this.loading = false;
        this.produtoDialog = false;
        this.produto = {};
        this.pesquisar();
      }
    });
  } catch (error) {
    this.loading = false;
    alert(error)
  }
  }

  fecharDialogo() {
    this.produtoDialog = false;
    this.submitted = false;
  }
  
  limparCampos() {
    this.produto.categoria = "";
    this.produto.codigo_empresa = "";
    this.produto.estoque = 0;
    this.produto.estoque_maximo = 0;
    this.produto.estoque_minimo = 0;
    this.produto.imagem = "";
    this.produto.localizacao = "";
    this.produto.marca = "";
    this.produto.observacao = "";
    this.produto.produto = "";
    this.produto.valor_custo = 0;
    this.produto.valor_venda = 0;
  }

  uploadedFiles:File = null;
  onFileSelected(event) {
    console.log(event);
    this.uploadedFiles = <File>event.target.files[0];
    // this.messageService.add({severity: 'info', summary: 'Imagem Salva', detail: ''});
 }

 
  onUpload(produto:ProdutoModel){
    try {
      if(this.uploadedFiles != null){
      let resposta = this.service.onUpload(this.uploadedFiles, produto.cod_produto);
      resposta.subscribe(data => {
        console.log(data);
        if(data.Success)
        {      
          this.messageService.add({severity:'success', summary:'Informação', detail: data.Message});  
          this.path_imagem = data.Response.imagem;      
        }else{
          this.messageService.add({severity:'error', summary:'Informação', detail: data.Message});
        }
      });
    }
    } catch (error) {
      alert(error)
    }
  }
}
